
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { TabMenu, TabMenuItem, Flex, FlexItem, FlexJustify, Spinner, Badge, Category, Icon, Size, TabMenuLink } from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground, { PropsTable } from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Tab Menu`}</h1>
<p>{`It is primarily used to change the context of a whole page, that is in contrast with `}<inlineCode parentName="p">{`SegmentedControl`}</inlineCode>{` which only should modify part of a page's content.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { TabMenu, TabMenuItem, TabMenuLink } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<p>{`This is the most basic usage of a tab menu, composed of multiple TabMenuItems`}</p>
<Playground __position={0} __code={`<TabMenu>
  <TabMenuItem active text="First option" />
  <TabMenuItem text="Second option" />
  <TabMenuItem text="Third option" />
</TabMenu>`} component={TabMenu} mdxType="Playground">
  <TabMenu mdxType="TabMenu">
    <TabMenuItem active text="First option" mdxType="TabMenuItem" />
    <TabMenuItem text="Second option" mdxType="TabMenuItem" />
    <TabMenuItem text="Third option" mdxType="TabMenuItem" />
  </TabMenu>
</Playground>
<p>{`However it can also be set vertically:`}</p>
<Playground __position={1} __code={`<div style={{ maxWidth: 300 }}>
  <TabMenu vertical>
    <TabMenuItem active text="First option" />
    <TabMenuItem text="Second option" />
    <TabMenuItem text="Third option" />
  </TabMenu>
</div>`} mdxType="Playground">
  <div style={{
        maxWidth: 300
      }}>
    <TabMenu vertical mdxType="TabMenu">
      <TabMenuItem active text="First option" mdxType="TabMenuItem" />
      <TabMenuItem text="Second option" mdxType="TabMenuItem" />
      <TabMenuItem text="Third option" mdxType="TabMenuItem" />
    </TabMenu>
  </div>
</Playground>
<h4>{`TabMeu Item`}</h4>
<Playground __position={2} __code={`<TabMenuItem text="I'm an item" />`} component={TabMenuItem} mdxType="Playground">
  <TabMenuItem text="I'm an item" mdxType="TabMenuItem" />
</Playground>
<h4>{`TabMeu Link`}</h4>
<p>{`Extends the `}<inlineCode parentName="p">{`TabMenuItem`}</inlineCode>{` props but adds `}<inlineCode parentName="p">{`href`}</inlineCode>{` and `}<inlineCode parentName="p">{`linkComponent`}</inlineCode></p>
<PropsTable component={TabMenuLink} mdxType="PropsTable" />
<p>{`You can also give leading and trailing to items, and disable them:`}</p>
<Playground __position={4} __code={`<TabMenu>
  <TabMenuItem active text="First option" trailing={<Spinner size={Size.SMALL}  />} />
  <TabMenuItem text="Second option" trailing={<Badge value={5} category={Category.DANGER} />} />
  <TabMenuItem text="Third option" disabled leading={<Icon name="brand-id" />} />
</TabMenu>`} mdxType="Playground">
  <TabMenu mdxType="TabMenu">
    <TabMenuItem active text="First option" trailing={<Spinner size={Size.SMALL} mdxType="Spinner" />} mdxType="TabMenuItem" />
    <TabMenuItem text="Second option" trailing={<Badge value={5} category={Category.DANGER} mdxType="Badge" />} mdxType="TabMenuItem" />
    <TabMenuItem text="Third option" disabled leading={<Icon name="brand-id" mdxType="Icon" />} mdxType="TabMenuItem" />
  </TabMenu>
</Playground>
<h3>{`Link component and links`}</h3>
<p>{`If you want to use the tabs to navigate with links rather than with the `}<inlineCode parentName="p">{`onClick`}</inlineCode>{` function, you can use `}<inlineCode parentName="p">{`TabMenuLink`}</inlineCode>{`.`}</p>
<Playground __position={5} __code={`<TabMenu>
  <TabMenuLink href="#1" active text="First option" />
  <TabMenuLink href="#2" text="Second option" />
  <TabMenuLink href="#2" text="Third option" />
</TabMenu>`} mdxType="Playground">
  <TabMenu mdxType="TabMenu">
    <TabMenuLink href="#1" active text="First option" mdxType="TabMenuLink" />
    <TabMenuLink href="#2" text="Second option" mdxType="TabMenuLink" />
    <TabMenuLink href="#2" text="Third option" mdxType="TabMenuLink" />
  </TabMenu>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;